import CategoriesModel from "../models/categories.model";
import { Category } from "../types/categories";
import { useReducerAsState } from "./useReducerAsState";

interface State {
    categories: Array<Category>;
    loadingCategories: boolean;
    errorCategories: string;
}

interface CategoriesResult {
    categories: Category[];
}

const useCategories = () => {

    const [state, setState] = useReducerAsState<State>({
        categories: [],
        loadingCategories: false,
        errorCategories: "",
    });

    const { categories, loadingCategories, errorCategories } = state

    const fetchCategories = async () => {
        setState({ loadingCategories: true, errorCategories: "" })
        const response = await CategoriesModel.getAll()

       if(response.error){
        setState({ loadingCategories: false, errorCategories: response.error, categories: [] })
        return
       }

       const result = response.data as CategoriesResult
       const categories = result.categories.sort((cat1, cat2) => cat1.id - cat2.id)
       setState({ loadingCategories: false, errorCategories: "", categories  })
    }

    return { categories, loadingCategories, errorCategories, fetchCategories }
}

export default useCategories